import Amplitude from "@Shared/utils/amplitude";
export default Vue => {
  Vue.config.errorHandler = (error, vm, info) => {
    //ignore aborted/cancelled request errors
    if ((error == null ? void 0 : error.status) === 0 && (error == null ? void 0 : error.statusText) === "abort") return;
    console.error(error);
    Amplitude.logUnhandledError(error, {
      source: "vue",
      severity: "fatal",
      customData: {
        info
      }
    });
  };
};